export default "__VITE_ASSET__7b402edf__"